var _style, _path, _path2, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClams(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1C8079;}\n\t.st1{fill:#E0B879;}\n\t.st2{clip-path:url(#SVGID_2_);}\n\t.st3{fill:#AA8F69;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M103.42,184.22c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C26.12,149.93,60.73,184.22,103.42,184.22"
  })), /*#__PURE__*/React.createElement("g", null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M80.91,76.92c10.98-21.26,48.21,9.54,65.89,20.13c17.68,10.59,8.1,45.76-42.62,46.09 c-50.72,0.33-59.48-29.78-43.69-38.02C72,99.13,80.91,76.92,80.91,76.92z"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M80.91,76.92c10.98-21.26,48.21,9.54,65.89,20.13c17.68,10.59,8.1,45.76-42.62,46.09 c-50.72,0.33-59.48-29.78-43.69-38.02C72,99.13,80.91,76.92,80.91,76.92z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M98.3,91.38c8.58-0.42,14.03-4.92,15.46-8.91c0.6-1.67,0.8-4.14-1.66-6.37l4-4.41 c3.76,3.41,4.95,8.07,3.27,12.78c-2.58,7.2-10.92,12.37-20.77,12.85c-2.44,0.12-4.69,0.05-6.75-0.18 C78,95.65,72.63,87.48,72.38,87.08l5.03-3.19C77.45,83.97,82.83,92.14,98.3,91.38z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M87.77,107.8c17.91,4.57,28.13,0.23,32.61-2.76c5.84-3.89,8.98-8,9.35-12.23c0.47-5.37-3.78-9.49-3.82-9.52 l3.95-4.23c0.26,0.24,6.31,5.99,5.63,14.17c-0.5,6.1-4.51,11.69-11.91,16.62c-4.35,2.9-13.16,6.9-27.35,5.37 c-3.05-0.33-6.35-0.91-9.9-1.82c-14.07-3.58-18.32-15.53-18.61-21.34l5.78-0.3C73.54,92.28,74.4,104.4,87.77,107.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M75.84,125.49c17.51,7.52,43.74,7.07,56.14-0.96c12.59-8.16,16.03-15.13,14.16-28.67l5.61-0.77 c2.19,15.84-2.17,24.79-16.69,34.19c-9.36,6.07-25.06,8.36-40.21,6.73c-7.49-0.81-14.84-2.57-21.23-5.32 c-10.32-4.44-14.44-11.57-16.08-16.78c-1.78-5.66-1.07-10.3-1.04-10.5l5.59,0.88C61.99,104.88,60.11,118.73,75.84,125.49z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClams);
export default __webpack_public_path__ + "static/media/Clams.c7beb12d09e25b6762510953e3b143cf.svg";
export { ForwardRef as ReactComponent };